import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { fileUrl } from "../lib/api";
import { Printer } from "lucide-react";

export default function JobTicket() {
  const { order_id, item_index } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => {
    api.get(`/orders/${order_id}`).then((r) => setOrder(r.data)).catch(() => setOrder(null));
  }, [order_id]);

  if (!order) {
    return <div className="p-10 overline text-neutral-400">Cargando ticket…</div>;
  }
  const item = order.items[parseInt(item_index)];
  if (!item) return <div className="p-10 text-red-600">Item no encontrado</div>;

  return (
    <div className="min-h-screen bg-white">
      <style>{`@media print { .no-print { display:none !important; } body { background:#fff; } }`}</style>
      <div className="no-print sticky top-0 bg-white border-b border-neutral-200 px-6 py-3 flex items-center justify-between z-10">
        <div className="overline text-neutral-500">Ticket de impresión · Pedido #{order.id.slice(0, 8).toUpperCase()}</div>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-black text-white px-4 py-2 overline text-xs hover:bg-neutral-800" data-testid="ticket-print-btn">
          <Printer size={14} /> Imprimir / Guardar PDF
        </button>
      </div>

      <div className="max-w-[820px] mx-auto p-10" data-testid="job-ticket">
        <div className="flex items-start justify-between border-b border-neutral-900 pb-4 mb-8">
          <div>
            <div className="font-serif text-3xl font-light">d-<span className="italic">Pod</span> <span className="text-neutral-400 overline text-xs tracking-[0.3em] ml-1">Gallery</span></div>
            <div className="overline text-[10px] text-neutral-500 mt-1">Ticket de impresión · 123imprime</div>
          </div>
          <div className="text-right">
            <div className="overline text-[10px] text-neutral-500">Pedido</div>
            <div className="font-mono text-xl">#{order.id.slice(0, 8).toUpperCase()}</div>
            <div className="text-xs text-neutral-500 mt-1">{new Date(order.created_at).toLocaleDateString()}</div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-5">
            <div className="aspect-square bg-neutral-50 border border-neutral-200 overflow-hidden">
              <img src={fileUrl(item.image_path, "lg")} alt="" className="w-full h-full object-contain" />
            </div>
            <div className="mt-3 text-xs text-neutral-500 break-all" data-testid="ticket-image-url">
              <strong>URL original:</strong><br />{fileUrl(item.image_path, "orig")}
            </div>
          </div>

          <div className="col-span-7">
            <h1 className="font-serif text-3xl font-light leading-tight">{item.title}</h1>
            <div className="text-sm text-neutral-600 mt-1">de <strong>{item.artist_name}</strong></div>

            <div className="mt-8 border-t border-neutral-200">
              <Row label="Cantidad" value={`${item.quantity} unidad${item.quantity > 1 ? "es" : ""}`} highlight />
              <Row label="Talla" value={item.size_label || "—"} />
              <Row label="Dimensiones" value={`${item.width_cm} × ${item.height_cm} cm`} highlight />
              <Row label="Material" value={item.material_name || item.material || "Fine Art Etching 310gr"} highlight />
              {item.is_exclusive_buyout && <Row label="Tipo" value="COMPRA EN EXCLUSIVA" highlight />}
              {item.impressions_acquired && <Row label="Impresiones a entregar" value={item.impressions_acquired} highlight />}
            </div>

            <div className="mt-8 border border-neutral-900 p-5 bg-neutral-50">
              <div className="overline text-[10px] text-neutral-700">Envío a</div>
              <div className="mt-2 text-sm leading-relaxed">
                <strong>{order.shipping_name}</strong><br />
                {order.shipping_address}<br />
                {order.shipping_city}, {order.shipping_country}<br />
                <span className="text-neutral-500">{order.shipping_phone} · {order.shipping_email}</span>
              </div>
            </div>

            <div className="mt-6 text-xs text-neutral-500 leading-relaxed">
              <div className="overline text-neutral-700 mb-2">Notas para producción</div>
              <ul className="list-disc pl-5 space-y-1">
                <li>Verificar perfil de color del archivo antes de imprimir.</li>
                <li>Adjuntar certificado de autenticidad firmado por el artista.</li>
                <li>Embalaje: tubo + protectores en bordes.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-4 border-t border-neutral-200 flex items-center justify-between text-xs text-neutral-400">
          <span>{order.shipping_city} · {new Date().toLocaleString()}</span>
          <span>d-Pod Gallery · proyecto 123imprime · d-impresión</span>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value, highlight }) {
  return (
    <div className={`flex justify-between py-3 border-b border-neutral-200 ${highlight ? "font-medium text-neutral-900" : "text-neutral-600"}`}>
      <span className="overline text-[10px] text-neutral-500">{label}</span>
      <span className="text-sm">{value}</span>
    </div>
  );
}
